export default function applyCountdown({
  selector,
  template,
  onFinish = () => {}
}) {
  vendorManager.ensure('jquery.countdown', () => {
    const countdown = $(selector);
    const finalDate = countdown.data('value');

    if (countdown && countdown.length > 0) {
      countdown
        .countdown(finalDate, function (event) {
          $(this).html(event.strftime(template));
        })
        .on('finish.countdown', onFinish);
    }
  });
}
